import { render, staticRenderFns } from "./upperFooter.vue?vue&type=template&id=2d328eb2"
import script from "./upperFooter.vue?vue&type=script&lang=js"
export * from "./upperFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports